import { render, staticRenderFns } from "./dependentes.vue?vue&type=template&id=61d824a5&"
import script from "./dependentes.vue?vue&type=script&lang=js&"
export * from "./dependentes.vue?vue&type=script&lang=js&"
import style0 from "./dependentes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports